import { isEmpty } from 'lodash';
import { OrderedListTypeAttribute } from 'types/html';
import {
  ListFormattingType,
  UnorderedListFormattingType,
  OrderedListFormattingType, NumberingItem,
} from 'clients/documents/documentsClient.types';

export const getListStyle = (type: UnorderedListFormattingType) => {
  const map = {
    [ListFormattingType.Dash]: '"-\\  "',
    [ListFormattingType.Dot]: 'disc',
  };

  return map[type];
};

export const getListNumberingType = (type: OrderedListFormattingType): OrderedListTypeAttribute => {
  const map = {
    [ListFormattingType.Alphabet]: 'a' as OrderedListTypeAttribute,
    [ListFormattingType.AlphabetCapital]: 'A' as OrderedListTypeAttribute,
    [ListFormattingType.ArabicNumbers]: '1' as OrderedListTypeAttribute,
    [ListFormattingType.RomanNumerals]: 'I' as OrderedListTypeAttribute,
    [ListFormattingType.RomanNumeralsCapital]: 'I' as OrderedListTypeAttribute,
  };

  return map[type];
};

export const renderArticleComparisonNumbering = (
  numbering_data: NumberingItem[] | null | undefined,
): string => {
  return numbering_data?.map(i => i.label ?? '').filter(Boolean).join('.') ?? '';
};

export const NUMBERING_DOT = <span style={{ color: 'gray' }}> • </span>;

export const renderBlockComparisonNumbering = (
  numbering_data: NumberingItem[] | null | undefined,
): JSX.Element => {
  if (!numbering_data || numbering_data.length === 0) {
    return <></>;
  }

  if (isEmpty(numbering_data)) {
    return <></>;
  }

  return (
    <>
      {numbering_data.map((i, idx) => (
        <span key={idx}>
          {i.label}
          {idx < numbering_data.length - 1 && NUMBERING_DOT}
        </span>
      ))}
    </>
  );
};

